// Section heading primitive. Pages render it between widget clusters
// so the section taxonomy in widgetRegistry.js is visible to the reader.
//
// Postgres mapping: none (presentation).
// Integration hook: none.
import React from 'react';
import { Box, Typography } from '@mui/material';

// Section heading shown above a cluster of widgets, matches the "Score
// drivers" label used at the top of the FactorStrip. Pages call this between
// section blocks so the customise drawer's section list lines up exactly
// with what the reader sees on the page.

export default function SectionTitle({ children, sx }) {
    return (
        <Box sx={{ mt: 0, mb: 0, px: 0.5, ...sx }}>
            <Typography sx={{
                fontSize: 10,
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                color: 'text.disabled',
            }}>
                {children}
            </Typography>
        </Box>
    );
}
